export const formatDate = (dateString: string): Date => {
  const [d, m, y] = dateString.split('/');
  return new Date(Number(y), Number(m) - 1, Number(d));
};

export const isDeletable = (startDate: Date): boolean => {
  return startDate.getTime() >= new Date().setHours(0, 0, 0, 0);
};
